// extracted by mini-css-extract-plugin
export default {"alt-sum-tooltip":"EditAltSumm_alt-sum-tooltip__BmJ7p","altSumTooltip":"EditAltSumm_alt-sum-tooltip__BmJ7p"};